// eslint-disable-next-line import/prefer-default-export
import Vue from "vue";
export const companyMutations = {
    SET_COMPANY: (state, payload) => {
        Vue.set(state, 'company', payload)
    }
};
